import { useQuery } from '@tanstack/react-query'

import type { TAtendimento } from '@/features/atendimento/interfaces'
import { GetAtendimentoAtivoService } from '@/features/atendimento/services'
import { atendimentoKeys } from '@/features/atendimento/utils/queries'
import { useLocalStorage } from '@/hooks'

export const useAtendimentoAtivo = (enabled: boolean) => {
  const [_, setAtendimentoAtivo] = useLocalStorage<TAtendimento | null>('atendimento', null)
  return useQuery({
    queryKey: atendimentoKeys.atendimentoAtivo(),
    queryFn: async () =>
      new GetAtendimentoAtivoService().execute().then((response) => {
        setAtendimentoAtivo(response)
        return response
      }),
    retry: false,
    enabled,
  })
}
